<template>
  <div
      v-if="!isMobileBreakpoint && allowedBranches.length > 1"
      class="calculator__branches"
  >
    <BaseCalculatorBranchIcon
        v-for="branchOption in allowedBranches"
        :key="`branch-option-${branchOption.slug}`"
        :branch="branchOption"
        :selected="branchOption.slug === branch?.slug"
        :deselected="!!branch?.slug && branch.slug !== branchOption.slug"
        @click.prevent="onSelectBranch(branchOption)"
    />
  </div>
  <div
      v-else-if="allowedBranches.length > 1"
      class="calculator__branches--mobile"
  >
    <SelectField
        label="Produkt auswählen"
        custom-list-class="custom-branch-list"
        :options="allowedBranchesOptions"
        :model-value="branch?.slug"
        :icon-left="getOptionImageUrl(branch?.slug)"
        @update:modelValue="onSelectBranch($event)"
        position-absolute
    >
      <template v-slot:option="{ option }">
        <span class="custom-branch-option">
          <span>
            <img :src="getOptionImageUrl(option.value)" :alt="`Icon ${option.label}`">
          </span>
          <span>{{ option.label }}</span>
        </span>
      </template>
    </SelectField>
  </div>
</template>

<script setup lang="ts">
import BaseCalculatorBranchIcon from '@/components/BaseCalculator/BaseCalculatorBranchIcon.vue';
import SelectField from '@/components/SelectField.vue';
import BranchInterface from '@/interfaces/BranchInterface';
import { computed, inject, Ref } from 'vue';

const branch = defineModel<BranchInterface | undefined>();

const props = withDefaults(defineProps<{
  allowedBranches: BranchInterface[]
}>(), {
  allowedBranches: () => ([]),
});

const isMobileBreakpoint = inject('isMobileBreakpoint') as Ref<boolean>;

const allowedBranchesOptions = computed(() => [...props.allowedBranches].map((allowedBranch: BranchInterface) => ({
  value: allowedBranch.slug,
  label: allowedBranch.name,
})));

const getOptionImageUrl = (branchSlug: string): string | undefined => props.allowedBranches.find((allowedBranch) => allowedBranch.slug === branchSlug)?.image?.url;

const onSelectBranch = (branchOption: BranchInterface | string) => {
  let selectedBranchOption = branchOption;

  if (typeof selectedBranchOption === 'string') {
    selectedBranchOption = [...props.allowedBranches].find((allowedBranch) => allowedBranch.slug === selectedBranchOption);
  }

  if (branch.value?.slug === selectedBranchOption.slug) {
    branch.value = undefined;

    return;
  }

  branch.value = { ...selectedBranchOption };
};
</script>

<style lang="scss">
.calculator__branches {
  display: flex;
  gap: 30px;

  > div {
    flex: 0 1 auto;
  }

  &--mobile {
    max-width: 646px;
  }
}

.custom-branch-list {
  li {
    & + li {
      border-top: 1px solid #ECF2F6;
    }
  }
}

.custom-branch-option {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 15px;
  align-items: center;

  img {
    display: block;
    height: 1.6252rem;
    width: auto;
  }
}
</style>
